module.exports = __webpack_public_path__ + "static/html5-330906d53404572e0882f4c4ff5680e6.png";